const structuredDataEasyProjectEN = {
    "@context": "https://schema.org",
    "@graph":
        [
            {
                "@type": "Product",
                "@id": "https://www.easyproject.com/product",
                "name": "Easy Project",
                "image": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyProject/media/system/favicon/favicon-96x96.png",
                "description": "Plan, scale and deliver complex projects and services, all in one AI-powered suite. Easy Project is the most adaptable & secure project and work management tool on the market for individuals, teams, and whole companies.",
                "brand": {
                    "@type": "Brand",
                    "name": "Easy Project"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1",
                    "ratingCount": 26
                }
            },
            {
                "@type": "Organization",
                "url": "https://www.easyproject.com/",
                "logo": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyProject/media/system/favicon/favicon-96x96.png",
                "sameAs": [
                    "https://www.facebook.com/EasyProjectcom",
                    "https://www.linkedin.com/company/easy-software-ltd./",
                    "https://twitter.com/easyredmine",
                    "https://www.youtube.com/@EasyRedmine"
                ]
            },
            {
                "@type": "WebSite",
                "name": "Easy Project",
                "url": "https://www.easyproject.com/"
            }
        ]
}

const structuredDataEasyProjectCS = {
    "@context": "https://schema.org",
    "@graph":
        [
            {
                "@type": "Product",
                "@id": "https://www.easyproject.cz/product",
                "name": "Easy Project",
                "image": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyProject/media/system/favicon/favicon-96x96.png",
                "description": "Vaše projekty, helpdesk a správa zdrojového kód na jedné platformě s podporou AI. S Easy Projectem získáte jeden nástroj pro efektivní využití vašich zdrojů, dokumentů, informací, které zaručeně vedou ke zvýšení produktivity.",
                "brand": {
                    "@type": "Brand",
                    "name": "Easy Project"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1",
                    "ratingCount": 26
                }
            },
            {
                "@type": "Organization",
                "url": "https://www.easyproject.cz/",
                "logo": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyProject/media/system/favicon/favicon-96x96.png",
                "sameAs": [
                    "https://www.facebook.com/EasyProjectcom",
                    "https://www.linkedin.com/company/easy-software-ltd./",
                    "https://twitter.com/easyredmine"
                ]
            },
            {
                "@type": "WebSite",
                "name": "Easy Project",
                "url": "https://www.easyproject.cz/"
            }
        ]
}

const structuredDataEasyProjectHU = {
    "@context": "https://schema.org",
    "@graph":
        [
            {
                "@type": "Product",
                "@id": "https://www.easyproject.hu/termek",
                "name": "Easy Project",
                "image": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyProject/media/system/favicon/favicon-96x96.png",
                "description": "A hibrid projektmenedzsment, az IT szolgáltatásmenedzsment és a forráskódmenedzsment hatékony kombinációja egy AI által támogatott rendszerben. Az Easy Project egy integrált platform, amely optimalizálja az erőforrásokat, biztosítja a projektek időben történő teljesítését, növeli a termelékenységet és maximalizálja a nyereséget.",
                "brand": {
                    "@type": "Brand",
                    "name": "Easy Project"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1",
                    "ratingCount": 26
                }
            },
            {
                "@type": "Organization",
                "url": "https://www.easyproject.hu/",
                "logo": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyProject/media/system/favicon/favicon-96x96.png",
                "sameAs": [
                    "https://www.facebook.com/EasyProjectcom",
                    "https://www.linkedin.com/company/easy-software-ltd./",
                    "https://twitter.com/easyredmine",
                    "https://www.youtube.com/@EasyRedmine"
                ]
            },
            {
                "@type": "WebSite",
                "name": "Easy Project",
                "url": "https://www.easyproject.hu/"
            }
        ]
}

const structuredDataEasyRedmine = {
    "@context": "https://schema.org",
    "@graph":
        [
            {
                "@type": "Product",
                "@id": "https://www.easyredmine.com/product",
                "name": "Easy Redmine",
                "image": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyRedmine/media/system/favicon/favicon-96x96.png",
                "description": "Project & work management solution redefining technology projects by combining Agile & Waterfall, IT service management, and source code management into one integrated AI-powered suite. Easy Redmine is one unified platform that optimizes resources, ensures on-time project delivery, boosts productivity, and maximizes margins.",
                "brand": {
                    "@type": "Brand",
                    "name": "Easy Redmine"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.5",
                    "bestRating": "5",
                    "worstRating": "1",
                    "ratingCount": 100
                }
            },
            {
                "@type": "Organization",
                "url": "https://www.easyredmine.com/",
                "logo": "https://preprod1-admin.easysoftware.client.puxdesign.cz/EasyRedmine/media/system/favicon/favicon-96x96.png",
                "sameAs": [
                    "https://www.facebook.com/easyredmine/",
                    "https://www.linkedin.com/company/easy-software-ltd./",
                    "https://twitter.com/easyredmine",
                    "https://www.youtube.com/@EasyRedmine"
                ]
            },
            {
                "@type": "WebSite",
                "name": "Easy Redmine",
                "url": "https://www.easyredmine.com/"
            }
        ]
}

export function getHomepageSchemaOrg() {
    const activeProject = process.env.PROJECT || `EasyRedmineGatsby`
    const locale = process.env.LOCALE || `en`

    if (activeProject === `EasyProjectGatsby`) {
        switch (locale) {
            case `en`:
                return structuredDataEasyProjectEN
            case `cs`:
                return structuredDataEasyProjectCS
            case `hu`:
                return structuredDataEasyProjectHU
        }
    }

    return structuredDataEasyRedmine
}
